const URL = {
  DOCUMENT_PDF_UPLOAD: 'Media/UploadPdf',
}
export default URL
